<template>
  <div id="new-list">
    <!-- <FlashBanner :message="flashMessage.message" :status="flashMessage.status"/> -->
    <button @click="newList" v-if="!showForm">New list</button>
    <form class="board-list" @submit.prevent="createList" v-if="showForm">
      <label for="name">What should we call this list?</label>
      <input type="text" name="name" placeholder="e.g. Choose colors" v-model="list.name" />
      <button class="save" @submit.prevent="createList" :class="{isLoading: isLoading}">Create</button>
      <button class="cancel" @click.prevent="clearForm" :class="{isLoading: isLoading}">Cancel</button>
      <span class="loading">
        <img v-if="isLoading" src="@/assets/images/rolling.svg" alt />
      </span>
    </form>
  </div>
</template>
<script>
import uuidv1 from "uuid/v1";
import { EventBus } from "@/eventbus";

// import db from "@/fb/init";
// import FlashBanner from "@/components/FlashBanner";

export default {
  name: "NewList",
  components: {},
  props: ["board_id"],
  data() {
    return {
      showForm: false,
      isLoading: false,
      // flashMessage: { message: null, status: null },
      list: {
        list_id: null,
        name: null,
        board_id: null,
        isCollapsed: false
      }
    };
  },
  methods: {
    newList() {
      this.showForm = true;
    },
    createList() {
      if (this.list.name) {
        EventBus.$emit("clearFlash");
        this.list.board_id = this.board_id;
        this.list.list_id = uuidv1();
        const list = Object.assign({}, this.list);
        EventBus.$emit("createList", list);
        this.clearForm();
        this.isLoading = false;
      } else {
        const messageObj = {
          message: "We need some sort of name",
          status: "error",
          duration: 3000
        };
        EventBus.$emit("showFlash", messageObj);
      }
    },
    clearForm() {
      this.showForm = false;
      this.list.list_id = null;
      this.list.name = null;
    }
  }
};
</script>
